import { motion } from "framer-motion";
import { SPECIALTIES } from "../data";

const IMG_POS = {
  Tacos: "center 72%",
  Lonches: "center 75%",
  Quesibarbacoa: "center 70%",
  Consomé: "center 62%",
};

export const Specialties = () => {
  return (
    <section
      id="especialidades"
      data-testid="specialties-section"
      className="relative py-20 md:py-28 bg-[#FBF5EA]"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl mb-14">
          <motion.p
            initial={{ opacity: 0, y: 12 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.5 }}
            className="text-brand-gold uppercase tracking-[0.3em] text-xs mb-4"
          >
            Nuestras especialidades
          </motion.p>
          <motion.h2
            initial={{ opacity: 0, y: 18 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.6, delay: 0.1 }}
            className="font-display text-3xl lg:text-5xl font-bold text-brand-burgundy leading-tight"
          >
            Lo que nos hace una herencia
          </motion.h2>
          <motion.p
            initial={{ opacity: 0, y: 18 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="mt-4 text-brand-burgundy/70 leading-relaxed"
          >
            Cada platillo nace de la receta familiar: barbacoa de res cocida
            lento, sazonada con tradición y servida con orgullo norteño.
          </motion.p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
          {SPECIALTIES.slice(0, 4).map((s, i) => (
            <motion.article
              key={s.name}
              data-testid={`specialty-card-${i}`}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, delay: i * 0.08 }}
              className="group relative overflow-hidden bg-white border border-brand-gold/25 rounded-2xl hover:border-brand-gold hover:shadow-xl hover:shadow-brand-burgundy/10 transition-all duration-500"
            >
              <div className="relative h-72 sm:h-80 lg:h-96 overflow-hidden">
                <img
                  src={s.img}
                  alt={s.name}
                  style={{ objectPosition: IMG_POS[s.name] || "center" }}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                />
                <span className="absolute top-4 left-4 text-[11px] uppercase tracking-[0.2em] text-brand-base bg-brand-gold px-3 py-1 font-bold rounded-full">
                  {s.tag}
                </span>
              </div>
              <div className="p-6">
                <div className="flex items-center gap-3 flex-wrap">
                  <h3 className="font-display text-2xl font-bold text-brand-burgundy group-hover:text-brand-red transition-colors">
                    {s.name}
                  </h3>
                  {s.recommended && (
                    <span
                      data-testid="recommended-badge-quesibarbacoa"
                      className="text-[11px] font-bold uppercase tracking-widest text-brand-burgundy bg-brand-gold/15 border border-brand-gold/50 px-2.5 py-0.5 rounded-full"
                    >
                      ⭐ Recomendado
                    </span>
                  )}
                </div>
                <p className="mt-3 text-sm text-brand-burgundy/70 leading-relaxed">
                  {s.desc}
                </p>
              </div>
            </motion.article>
          ))}
        </div>

        {SPECIALTIES[4] && (
          <motion.article
            data-testid="specialty-card-featured"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.6, delay: 0.1 }}
            className="group mt-6 relative overflow-hidden bg-brand-burgundy border border-brand-gold/40 rounded-2xl grid grid-cols-1 md:grid-cols-2 hover:shadow-2xl hover:shadow-brand-burgundy/20 transition-all duration-500"
          >
            <div className="relative h-80 sm:h-96 md:h-auto md:min-h-[440px] overflow-hidden">
              <img
                src={SPECIALTIES[4].img}
                alt={SPECIALTIES[4].name}
                style={{ objectPosition: "center 58%" }}
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
              />
              <span className="absolute top-4 left-4 text-[11px] uppercase tracking-[0.2em] text-brand-base bg-brand-gold px-3 py-1 font-bold rounded-full">
                {SPECIALTIES[4].tag}
              </span>
            </div>
            <div className="p-8 md:p-10 flex flex-col justify-center">
              <p className="text-brand-gold uppercase tracking-[0.25em] text-xs mb-2">
                Novedad destacada
              </p>
              <h3 className="font-display text-3xl md:text-4xl font-bold text-brand-cream">
                {SPECIALTIES[4].name}
              </h3>
              <p className="mt-4 text-brand-sand leading-relaxed">
                {SPECIALTIES[4].desc}
              </p>
              <a
                href="#menu"
                data-testid="featured-order-btn"
                className="mt-6 inline-flex items-center gap-2 bg-brand-gold text-brand-base font-bold uppercase tracking-widest text-sm px-6 py-3.5 rounded-full hover:bg-brand-goldlight transition-colors w-fit"
              >
                Pídelos ahora
              </a>
            </div>
          </motion.article>
        )}

        <div className="mt-12 text-center">
          <a
            href="#menu"
            data-testid="specialties-order-btn"
            className="inline-flex items-center gap-2 bg-brand-burgundy text-brand-cream font-bold uppercase tracking-widest text-sm px-8 py-4 rounded-full hover:bg-brand-red transition-colors"
          >
            Ver menú completo
          </a>
        </div>
      </div>
    </section>
  );
};
